import { useEffect } from 'react';

export const useEnterKeyListener = (
  sendCodeButton: JQuery<HTMLElement>,
  showResendButton: boolean
) => {
  useEffect(() => {
    if (!showResendButton) {
      const listener = (event: KeyboardEvent) => {
        if (event.code === 'Enter' || event.code === 'NumpadEnter') {
          event.preventDefault();
          sendCodeButton.trigger('click');
        }
      };

      document.addEventListener('keydown', listener);
      return () => {
        document.removeEventListener('keydown', listener);
      };
    }
  }, [ sendCodeButton, showResendButton ]);
};
